<div class="lightTheme">
  <div *ngIf="isLoading" class="svg-loader"></div>
  <div class="d-flex flex-column page-header">
    Flowsheet Builder
  </div>

  <div class="d-flex search_filter_area ">
    <div id="searchBar" class="d-inline-block">
        <input type="text" class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
        <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
      </div>
  
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
      <mat-chip-listbox #chipList>
        <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
          {{globals.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
    <div class="tbl_head_action float-right">
      <span class="filterIcon" matTooltip="Add Filter" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth">&nbsp;</span>
      <span class="exportIcon" matTooltip="Export to Excel" 
      (click)="exporter.exportTable('xlsx', {fileName:'Flowsheet', sheet: 'Flowsheet_list'})"
      (keydown)="exporter.exportTable('xlsx', {fileName:'Flowsheet', sheet: 'Flowsheet_list'});"
      >&nbsp;</span>
    </div>
  </div>
  <div class="d-flex flex-column flowsheetTable">    
      <mat-table matTableExporter [dataSource]="flowsheetsListDetails" matSort matSortActive="flowSheetName​​" matSortDirection="asc" matSortDisableClear
                 #exporter="matTableExporter" hiddenColumns="[0,5]">
        <ng-container matColumnDef="Add">
          <mat-header-cell *matHeaderCellDef class="addBtn-col">
            <a class="actionIcon pointer" [routerLink]="['/flowsheetBuilder']" matTooltip="Add" mat-icon-button>
              <mat-icon class="action-icon-add"></mat-icon>
            </a>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="addBtn-col"></mat-cell>
        </ng-container>
        <ng-container matColumnDef="flowSheetName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Flowsheet Name</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.flowSheetName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="flowSheetDescription">
          <mat-header-cell *matHeaderCellDef class="description-col">Description</mat-header-cell>
          <mat-cell *matCellDef="let element" class="description-col"> {{element.flowSheetDescription}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="lastUpdatedTimeStamp">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified At​</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.lastUpdatedTimeStamp | date: 'yyyy-MM-dd T HH:mm:ss' }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="lastUpdatedBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified By​</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.lastUpdatedBy}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell *matHeaderCellDef><span class="ml4">Action</span></mat-header-cell>
          <mat-cell class="tbl_action" *matCellDef="let element;">
            <button class="actionIcon pointer" [routerLink]="['/flowsheetBuilder', {id:element.flowSheetId, isEdit: false, isAuthorized:!element.isUnauthorized}]" matTooltip="View" mat-icon-button>
              <mat-icon class="action-icon-view"></mat-icon>
            </button>
            <button *ngIf="!element.isUnauthorized" class="actionIcon pointer" [routerLink]="['/flowsheetBuilder', {id:element.flowSheetId, isEdit: true}]" matTooltip="Edit" mat-icon-button>
              <mat-icon class="action-icon-edit"></mat-icon>
            </button>
            <button *ngIf="!element.isUnauthorized" class="actionIcon pointer" (click)="deleteFlowSheet(element.flowSheetId)" matTooltip="Delete" mat-icon-button> 
              <mat-icon class="action-icon-delete"></mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>
      <div *ngIf="(flowsheetsListDetails.data.length === 0) && (!isLoading)" class="emptyRepoMsg">
        <span> There are no records to display.</span>
      </div>
      <mat-paginator #paginator [pageSizeOptions]="[10,20,30]" [pageSize]="10"  [hidden]="!flowsheetsListDetails.data.length">
      </mat-paginator>
    </div>
  <div class="clearfix"></div>
  <ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
</div>

